module.exports = __webpack_public_path__ + "img/crown-1.f417708.png";